import { includesByArrayType } from '../../utils/globals/array'
import { MultipleCbxSelectorOptions, MultipleCbxSelectorValues, PreselectedMultipleCbxSelector } from './types'
import { ItemCustomSelectDropDownRow } from '../CustomSelect/DropDown/types'

export const getNotChangingValuesOnPreSelected = (oldSelectedValues: MultipleCbxSelectorValues, preSelected: PreselectedMultipleCbxSelector) => {
    const result: MultipleCbxSelectorValues = []
    for (const element of oldSelectedValues) {
        if (!includesByArrayType(preSelected.selected, element)) {
            result.push(element)
        }
    }
    return result
}

export const separateOptionsBySelected = (items: ItemCustomSelectDropDownRow[], mySelectedValues: MultipleCbxSelectorValues) => {
    const options: MultipleCbxSelectorOptions = {
        unSelected: [],
        selected: []
    }
    for (const value of items) {
        if (includesByArrayType(mySelectedValues, String(value.value))) {
            options.selected.push(value)
        } else {
            options.unSelected.push(value)
        }
    }
    return options

}